<template>
  <div class="model-generator-container">
    <div class="model-generator-sidebar">
      <h5 class="text-center mb-20 font-30 bold-font">Model Generator</h5>

      <!-- Create Job Form -->
      <ModelGeneratorForm @job-created="handleJobCreated" />

      <!-- Job History -->
      <ModelGeneratorHistory
        :jobs="jobs"
        :selectedJobId="selectedJobId"
        :loading="loading"
        :totalCount="totalCount"
        @select-job="handleSelectJob"
        @load-more="handleLoadMore"
      />
    </div>

    <div class="model-generator-main">
      <ModelGeneratorDetail
        v-if="selectedJobId"
        :key="selectedJobId"
        :jobId="selectedJobId"
        @refresh="loadJobs"
      />
      <div v-else class="empty-state">
        <p>Select a job from the history to view details</p>
      </div>
    </div>
  </div>
</template>

<script>
import ModelGeneratorForm from '@/components/products/modelGenerator/ModelGeneratorForm.vue'
import ModelGeneratorHistory from '@/components/products/modelGenerator/ModelGeneratorHistory.vue'
import ModelGeneratorDetail from '@/components/products/modelGenerator/ModelGeneratorDetail.vue'
import BackTestApiService from '@/services/BackTestApiService'
import { jobTypes } from '@/const'

export default {
  name: 'ModelGenerator',
  components: {
    ModelGeneratorForm,
    ModelGeneratorHistory,
    ModelGeneratorDetail
  },
  data() {
    return {
      jobs: [],
      selectedJobId: null,
      loading: false,
      refreshInterval: null,
      totalCount: 0,
      currentPage: 1,
      pageSize: 100
    }
  },
  mounted() {
    this.loadJobs()
    // Auto-refresh job list every 30 seconds
    this.refreshInterval = setInterval(() => {
      this.loadJobs()
    }, 30000)
  },
  beforeDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  },
  methods: {
    async loadJobs(page = 1) {
      this.loading = true
      try {
        const response = await BackTestApiService.getBackTestList({
          page: page,
          pageSize: this.pageSize,
          jobType: jobTypes.modelGenerator
        })

        const data = response.data
        if (page === 1) {
          this.jobs = data.Items || []
        } else {
          this.jobs = [...this.jobs, ...(data.Items || [])]
        }

        this.totalCount = data.TotalCount || 0
        this.currentPage = data.CurrentPage || 1

        // Auto-select the most recent job if none selected
        if (!this.selectedJobId && this.jobs.length > 0) {
          this.selectedJobId = this.jobs[0].Id
        }
      } finally {
        this.loading = false
      }
    },
    handleJobCreated(jobId) {
      this.loadJobs()
      this.selectedJobId = jobId
    },
    handleSelectJob(jobId) {
      this.selectedJobId = jobId
    },
    handleLoadMore() {
      this.loadJobs(this.currentPage + 1)
    }
  }
}
</script>

<style scoped lang="scss">
.model-generator-container {
  display: flex;
  height: calc(100vh - 90px);
  background: #fff;
}

.model-generator-sidebar {
  width: 360px;
  border-right: 1px solid #ddd;
  padding: 20px;
  background-color: #f8f9fa;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  h5 {
    flex-shrink: 0;
  }

  ::v-deep .model-generator-form {
    flex-shrink: 0;
  }

  ::v-deep .model-generator-history {
    flex: 1;
    overflow-y: auto;
    margin-right: -20px;
    margin-bottom: -20px;
    padding-right: 20px;
    padding-bottom: 20px;
  }
}

.model-generator-main {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background-color: #fff;
}

.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;
  font-size: 16px;
}
</style>
